export function UUID(length = 20) {
  let x = "".padStart(length, "x");
  return x.replace(/x/g, () => {
    return ((Math.random() * 16) | 0).toString(16);
  });
}
